import type { VaultOperation } from "./bound-contract";

/** Shared wire/spec check: a funding leg must authorize exactly its redemption. */
export function fundingRedemptionIdentityMatches(leg: {
  readonly rail: string;
  readonly vaultOperation?: VaultOperation;
  readonly sourceRedemptions?: readonly VaultOperation[];
  readonly sourceChainRef: string;
  readonly sourceAccountRef: string;
  readonly sourceAssetId: string;
  readonly sourceAmountRaw: string;
  readonly minDestinationAmountRaw: string;
  readonly aggregatorProvider?: string;
}): boolean {
  if (leg.sourceRedemptions) {
    const receipts = new Set<string>();
    if (
      (leg.rail !== "lifi_bridge" && leg.rail !== "cross_chain_swap") ||
      leg.vaultOperation ||
      leg.sourceRedemptions.length === 0 ||
      !leg.sourceRedemptions.every((redemption) => {
        const { binding } = redemption;
        if (receipts.has(binding.receiptAssetId)) return false;
        receipts.add(binding.receiptAssetId);
        return (
          redemption.kind === "redeem" &&
          binding.chainRef === leg.sourceChainRef &&
          binding.ownerAccountRef === leg.sourceAccountRef &&
          binding.underlyingAssetId === leg.sourceAssetId
        );
      })
    )
      return false;
  }
  const operation = leg.vaultOperation;
  if ((leg.rail === "lending_redeem") !== (operation !== undefined))
    return false;
  return (
    !operation ||
    (operation.kind === "redeem" &&
      operation.binding.chainRef === leg.sourceChainRef &&
      operation.binding.ownerAccountRef === leg.sourceAccountRef &&
      operation.binding.receiptAssetId === leg.sourceAssetId &&
      operation.amountRaw === leg.sourceAmountRaw &&
      operation.minOutputRaw === leg.minDestinationAmountRaw &&
      leg.aggregatorProvider === undefined)
  );
}
